import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import OriginalNumberInput from '~/components/common/NumberInput'

const NumberInput = ({
  field,
  form,
  inputProps,
  error,
  helperText,
  disabled,
  ...props
}) => (
  <OriginalNumberInput
    error={
      !!error ||
      (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name))
    }
    helperText={
      helperText ||
      (getIn(form.touched, field.name) && getIn(form.errors, field.name))
    }
    inputProps={{
      ...field,
      ...inputProps,
      value: field.value ?? '',
    }}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

NumberInput.defaultProps = {
  inputProps: {},
  error: '',
  helperText: '',
  disabled: false,
}

NumberInput.propTypes = {
  inputProps: PropTypes.shape(),
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  error: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
}

export default NumberInput
